import moment from 'moment';
import store from './vuex/store';
import authStoreTypes from './vuex/authorization/types';

export function humanizedDate(date: Date | string | undefined): string {
  if (!date) return '';

  const now = moment().utc();
  const duration = moment.duration(now.diff(moment.utc(date))).humanize();
  return `${duration.toString()} geleden`;
}

export function isNewerThanLastLogin(utcDate: any): boolean {
  return moment.utc(utcDate) > store.getters[authStoreTypes.getters.LAST_VISITED_DATE];
}

export function checkArray(value: any): any[] {
  return Array.isArray(value) ? value : [];
}